// import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { IconSvg } from '@iso/components/ScrumBoard/IconSvg/IconSvg';
import CloseIcon from '@iso/assets/images/icon/07-icon.svg';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 69px;
  background-color: #ffffff;
  border-bottom: 1px solid #e9e9e9;
`;

const ActionButtons = styled.div`
  > img {
    margin-right: 15px;
    border: none;
    width: 40px;
    margin-left: -5px;
  }
`;

// const IconButtons = styled.div`
//   > img {
//     margin-left: 15px;
//     margin-right: 0;
//   }
// `;

export default function CardDetailsHeader({
  onIconClick,
  onBtnClick,
  editing,
  columnId,
  // openDeleteModel,
  onEditCancel,
}) {
  return (
    <Container>
      {console.log("columnId :", columnId)}
      {console.log("editing :", editing)}
      <ActionButtons>
        <IconSvg src={CloseIcon} onClick={onIconClick} />
        {(["dataSource", "queues"].includes(columnId) && editing === true) && <Button htmlType="button" type="primary" onClick={onBtnClick}>
          Update
        </Button>}
        {onEditCancel && (
          <Button type="default" onClick={onEditCancel}>
            Cancel
          </Button>
        )}
      </ActionButtons>
      {/* <IconButtons>
        <Tooltip
          title="Please Implements Your Own Share Methods"
          placement="bottom"
        >
          <IconSvg src={ShareIcon} />
        </Tooltip>
        <Popconfirm
          title="Are you sure delete this?"
          okText="Yes"
          cancelText="No"
          onConfirm={onDelete}
          placement="bottomRight"
        >
          <IconSvg src={RemoveIcon} onClick={openDeleteModel} />
        </Popconfirm>
      </IconButtons> */}
    </Container>
  );
}
